import React, { useEffect, useMemo, useRef, useState } from 'react'

import { cn } from 'features/common/helpers/cn'
import { Activity, Location } from 'features/common/types'

export interface ActivityLabelProps {
  location?: Location
  activities: Activity[]
  color?: string
  reduce?: boolean
}

export const ActivityLabel: React.FC<ActivityLabelProps> = ({
  location,
  activities,
  color,
  reduce,
}) => {
  const prevPropRef = useRef<Location | undefined>(undefined)

  const [showCounter, setShowCounter] = useState<boolean>(true)

  const items = useMemo(() => {
    if (reduce && activities.length > 3) {
      return activities.slice(0, 3)
    }
    return [...activities]
  }, [activities, reduce])

  useEffect(() => {
    setShowCounter(true)
  }, [activities])

  useEffect(() => {
    const prevProp = prevPropRef.current

    if (prevProp && prevProp !== location) {
      setShowCounter(false)
    }

    prevPropRef.current = location
  }, [location, activities.length])

  return (
    <div className="flex items-center gap-1">
      {items.map((item, index) => (
        <div key={index}>
          <span className="text-base font-medium">{item.short_name}</span>
          {!!item.group_count && showCounter && (
            <span
              className={cn('text-base text-gray-500', !!color && color)}
            >{` (${item.group_count})`}</span>
          )}
          {items.length !== index + 1 && (
            <span className={cn('text-base text-gray-500', !!color && color)}>{' •'}</span>
          )}
        </div>
      ))}
      {activities.length > 3 && <span className="text-base font-medium">{'...'}</span>}
    </div>
  )
}

export default ActivityLabel
